import { useCallback, useContext } from "react";

import { SloContext } from "@components/hoc/slo-wrapper";

import { logoutRef } from "@stadium/services/auth/client";
import { client, getUnAuthLink } from "@services/apollo-client";
import { useAuth0V2, LOGOUT_CALLBACK_ROUTE } from "@stadium/services/auth0";
import { getAuth0ReturnToRoute } from "@stadium/services/auth0/utils";
import { useMutation } from "@stadium/services/apollo-client";
import { BASE_SHOPS_PATH } from "@constants/app-defaults";

import { destroySession } from "@graphql/mutations/session/destroy-session";
import { removeCookie } from "@stadium/helpers/cookie";

import { endImpersonationSession } from "@stadium/helpers/impersonation";

import { IS_AUTH0_ENABLED } from "@stadium/services/auth0/constants";
import { BYSTADIUM_MARKETING_URL } from "@stadium/helpers/src/app-routes";

const useLogout = (onLogout) => {
  const { logout: auth0Logout } = useAuth0V2();

  const { uid } = useContext(SloContext);
  const [deleteSessionRequest] = useMutation(destroySession);
  const destroySessionHandler = (uid) => deleteSessionRequest({ variables: { input: { uid } } });
  const logoutUser = useCallback(
    () =>
      auth0Logout({
        client_id: null,
        returnTo: getAuth0ReturnToRoute(
          IS_AUTH0_ENABLED
            ? {
                baseRoute: window.location.origin + LOGOUT_CALLBACK_ROUTE,
                params: {
                  returnTo: BYSTADIUM_MARKETING_URL,
                },
                fullUrl: true,
              }
            : {
                baseRoute: BYSTADIUM_MARKETING_URL,
                params: {},
                fullUrl: true,
              },
        ),
      }),
    [auth0Logout],
  );

  const postLogout = () => {
    client.setLink(getUnAuthLink());
    endImpersonationSession();
    onLogout?.();
    removeCookie("zapier_access_token", BASE_SHOPS_PATH);
    logoutUser();
  };

  const logoutAction = useCallback(() => {
    if (uid) {
      logoutRef.current = true;
      destroySessionHandler(uid)
        .catch((error) => {
          throw error;
        })
        .finally(() => {
          postLogout();
        });
    } else {
      postLogout();
    }
  }, [uid]);

  return {
    logoutAction,
  };
};

export default useLogout;
